

document.querySelectorAll('.mySwiper').forEach((container, index) => {
  new Swiper(container, {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 10,
    autoplay: {
      delay: 9000,
      disableOnInteraction: false
    },
    pagination: {
      el: container.parentElement.querySelector('.swiper-pagination'),
      clickable: true,
      dynamicBullets: false,
    },


  });
});



document.querySelectorAll('.swipernew ').forEach((container, index) => {
  new Swiper(container, {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: container.parentElement.querySelector('.swiper-button-next'),
      prevEl: container.parentElement.querySelector('.swiper-button-prev'),
    }, speed: 800,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }

  });
});



document.querySelectorAll('.image-gallery-slider').forEach((container, index) => {
  new Swiper(container, {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: container.parentElement.querySelector('.swiper-button-next'),
      prevEl: container.parentElement.querySelector('.swiper-button-prev'),
    }, speed: 800,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2.3,
        spaceBetween: 10
      },

      // when window width is >= 768px
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }

  });
});



document.querySelectorAll('.center-swiper').forEach((container, index) => {
  new Swiper(container, {
    slidesPerView: 3,
    // centeredSlides: true,
    // centeredSlidesBounds: true,
    // initialSlide: 0,
    spaceBetween: 20,
    navigation: {
      nextEl: container.parentElement.querySelector('.swiper-button-next'),
      prevEl: container.parentElement.querySelector('.swiper-button-prev'),
    }, speed: 800, breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.4,
        spaceBetween: 10,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: 1
      
      },

      // when window width is >= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 20

      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }


  });
});


// document.querySelectorAll('.center-swiperss').forEach((container, index) => {
//   new Swiper(container, {
//     slidesPerView: 3,
//     centeredSlides: true,
//     centeredSlidesBounds: true,
//     initialSlide: 0,
//     loop: true,
//     spaceBetween: 20,
//     navigation: {
//       nextEl: container.parentElement.querySelector('.swiper-button-next'),
//       prevEl: container.parentElement.querySelector('.swiper-button-prev'),
//     }, speed: 800, breakpoints: {
//       // when window width is >= 320px
//       320: {
//         slidesPerView: 1.4,
//         spaceBetween: 10
//       },

//       // when window width is >= 768px
//       768: {
//         slidesPerView: 3,
//         spaceBetween: 20

//       },
//       // when window width is >= 1024px
//       1024: {
//         slidesPerView: 3,
//         spaceBetween: 20
//       }
//     }


//   });
// });

document.querySelectorAll('.reviews-swiper').forEach((container, index) => {
  new Swiper(container, {
    slidesPerView: 3,
    centeredSlides: true,
    centeredSlidesBounds: true,
    initialSlide: 0,
    spaceBetween: 20,
    navigation: {
      nextEl: container.parentElement.querySelector('.swiper-button-next'),
      prevEl: container.parentElement.querySelector('.swiper-button-prev'),
    }, speed: 800, breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.4,
        loop: true,
        spaceBetween: 10,
      },

      // when window width is >= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 20

      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }


  });
});


document.querySelectorAll('.tab-swiper').forEach((container, index) => {
  new Swiper(container, {
    slidesPerView: 4,
    spaceBetween: 30,
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }, navigation: {
      nextEl: ".swiper-button-next2",
      prevEl: ".swiper-button-prev2",
    }, speed: 800,
    navigation: {
      nextEl: container.parentElement.querySelector('.swiper-button-next'),
      prevEl: container.parentElement.querySelector('.swiper-button-prev'),
    }, speed: 800,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.6,
        spaceBetween: 10
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  });
});



document.querySelectorAll(".mySwiperss").forEach((el, i) => {
  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true, // corrected
    navigation: {
      nextEl: el.parentElement.querySelector(".swiper-button-next"),
      prevEl: el.parentElement.querySelector(".swiper-button-prev")
    },
    speed: 800,
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      480: { slidesPerView: 1, spaceBetween: 10 },
      768: { slidesPerView: 1, spaceBetween: 10 },
      1024: { slidesPerView: 1, spaceBetween: 10 }
    }
  });
});


document.querySelectorAll('.category-list--item.category-list--item-arrow').forEach(item => {
  item.addEventListener('click', function() {
    const initialDiv = this.querySelector('.initial');
    
    if (initialDiv) {
      // Check if already open
      if (initialDiv.classList.contains('active')) {
        // Close - pehle animation, phir display none
        initialDiv.classList.remove('active');
        setTimeout(() => {
          initialDiv.style.display = 'none';
        }, 400); // CSS transition time ke baad
      } else {
        // Open - pehle display block, phir animation
        initialDiv.style.display = 'block';
        // Force browser to recognize display change
        void initialDiv.offsetWidth;
        // Ab animation start hogi
        initialDiv.classList.add('active');
      }
    }
  });
});